export const SHARED_BUSINESS_FLOW_PROCESS_FLOW_PHARMACY_PAYMENT_ENROLLMENT_TYPE = 'PharmacyPaymentEnrollment';
